/**
 * Return the default background color in the browser for an element.
 * 
 * @returns background color
 */
function getBrowserDefaultBackgroundColor() {
  // In order to use the getComputedStyle method, need to add to the DOM.
  const div = document.createElement('div');
  document.head.appendChild(div);
  var backgroundColor = window.getComputedStyle(div).backgroundColor;
  document.head.removeChild(div);
  return backgroundColor;
}

/**
 * Get the inherited background color for an element.
 * 
 * @param {*} element 
 * @returns background color for element.
 */
export function getInheritedBackgroundColor(element) {
  // Get default background-color style for the current browser:
  const defaultStyle = getBrowserDefaultBackgroundColor();
  const backgroundColor = window.getComputedStyle(element).backgroundColor;
  
  // Return the actual background colour if one is present:
  if (backgroundColor != defaultStyle) return backgroundColor;
  if (!element.parentElement) return defaultStyle;
  return getInheritedBackgroundColor(element.parentElement);
}